import { keepPreviousData } from '@tanstack/react-query';

import { GenericFailure } from '@playq/services-shared';
import { BillingConfiguration } from '@playq/services-taxman';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

export const corpBillingConfiguredQueryKeys: unknown[] = ['corp', 'billing', 'configured', 'query'];

export const useAdminBillingConfiguredQuery = (
  options?: IUseQueryOptionsExtended<BillingConfiguration | undefined, GenericFailure | Error>
) => {
  return useEitherQuery(corpBillingConfiguredQueryKeys, () => services2.adminBillingService.getConfig(), {
    placeholderData: keepPreviousData,
    ...options,
  });
};
